import { images } from './images'

export type Bonus = {
  number: string
  title: string
  body: string
  cover: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The Badminton Rules & Scoring Referee Card',
    body: 'Run and referee games without second-guessing yourself: scoring to 21, changing ends, legal serves, lets and the most common faults — plus how to explain it all to a group in 30 seconds.',
    cover: images.bonuses[0],
  },
  {
    number: '02',
    title: "The Coach's Equipment & Court Setup Guide",
    body: 'What to have ready before you step on court: feather vs nylon shuttles and who each is for, how many per player, net height, homemade targets, and how to set up one or two courts in minutes.',
    cover: images.bonuses[1],
  },
  {
    number: '03',
    title: 'The Shot Map & Terminology Poster',
    body: 'A printable A3 poster that maps every shot — where it starts, where it lands — plus a plain-English glossary, so you and your players speak the same language from day one.',
    cover: images.bonuses[2],
  },
  {
    number: '04',
    title: 'Blank Court Drill-Design Sheets',
    body: 'Top-down court templates — full court, half court, service boxes and net — with the pack\'s symbol legend, so you can draw your own drills in the same visual language.',
    cover: images.bonuses[3],
  },
  {
    number: '05',
    title: 'The 5-Minute Coaching Cues Cheat-Sheet',
    body: 'One pocket card with the single cue that changes each shot the most, and the most common error with its fix. Glance at it between drills and get back to coaching.',
    cover: images.bonuses[4],
  },
]
